var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41602 13.4167V0H4.58268V13.4167H3.41602Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58724 13.8292L1.25391 11.4959L2.07886 10.6709L3.99972 12.5918L5.92057 10.6709L6.74553 11.4959L4.4122 13.8292C4.18439 14.057 3.81505 14.057 3.58724 13.8292Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 1.16667H8.08301V0H12.1663C12.3873 0 12.5893 0.124835 12.6881 0.322459C12.7869 0.520083 12.7656 0.756573 12.633 0.933333L9.83301 4.66667H12.7497V5.83333H8.66634C8.44539 5.83333 8.24341 5.7085 8.1446 5.51087C8.04578 5.31325 8.06711 5.07676 8.19968 4.9L10.9997 1.16667Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.166 12.2499H8.66602V11.0833H12.166V12.2499Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9385 7.90572C10.8397 7.70809 10.6378 7.58325 10.4168 7.58325C10.1958 7.58325 9.9939 7.70809 9.89508 7.90572L7.13965 13.4166H8.44398L10.4168 9.47098L12.3896 13.4166H13.694L10.9385 7.90572Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sort-desc.eb8cd4101cae625fe3fbdb8294a760cc.svg";
export { ForwardRef as ReactComponent };